export default {
  title: '快递下单',
  steps: {
    basic: '基本信息',
    metrics: '件重尺',
    exclusive: '专属信息'
  },
  common: {
    clear: '清除',
    addFile: '添加文件',
    select: '请选择',
    required: '必填',
    optional: '选填',
    cancel: '取消',
    close: '关闭',
    saveDraft: '暂存草稿',
    previousStep: '上一页',
    nextStep: '下一页',
    confirmOrder: '确认下单',
    chooseFile: '选择文件',
    remove: '移除',
    storedInFiles: '已存入文件管理',
    reupload: '重新上传',
    no: '否',
    none: '无',
    yes: '是',
    pending: '待定',
    systemConfigured: '系统配置'
  },
  sections: {
    productDetails: '商品明细',
    expressService: '快递服务',
    cargoInfo: '物流信息',
    metrics: '件重尺',
    pieceDetails: '子单明细',
    contacts: '收发通信息',
    fedex: 'FedEx 专属信息',
    dhl: 'DHL 专属信息',
    importer: '进口方信息',
    importerOptional: '进口方信息（选填）',
    hsCodes: '商品 HSCode',
    hsCodeHint: '（按商品明细逐行；出口/进口均默认带入同一 HS，可由用户修改）'
  },
  fields: {
    shipDocumentType: '文档类型',
    carrier: '快递供应商',
    product: '快递产品',
    account: '下单账户',
    pickup: '上门提货',
    pickupTime: '取件时间',
    dutyPayment: '税费支付方',
    dutyAccount: '税费账号',
    englishName: '英文品名',
    chineseName: '中文品名',
    originCountry: '原产国',
    transportRemark: '运输备注',
    incoterm: '贸易条款',
    invoiceValue: '货值',
    currency: '币种',
    shipperPartyType: '发件地址类型',
    recipientPartyType: '收件地址类型',
    shipperCountry: '发件国家',
    recipientCountry: '收件国家',
    shipperPostcode: '发件邮编',
    recipientPostcode: '收件邮编',
    packagingType: '包裹类型',
    paymentType: '费用支付方',
    batteryDetails: '电池类型和包装',
    shipmentPurpose: '货物用途',
    recipientTaxId: '收件人税号',
    bookingNumber: '预定号码',
    loadCount: '箱数',
    fileUpload: '是否上传文件',
    fileUploadEnabled: '需要上传（传 true 时走 eTower 上传文件接口）',
    uploadFile: '上传文件',
    brokerSelection: '是否需要代理人自选',
    brokerSelectionEnabled: '需要代理人自选（勾选后填写下方代理人信息）',
    brokerName: '代理人名称',
    brokerPhone: '代理人电话',
    brokerCountry: '代理人国家',
    brokerState: '代理人省份',
    brokerCity: '代理人城市',
    brokerPostcode: '代理人邮编',
    brokerAddress: '代理人地址',
    invoice: '发票',
    invoiceOption: '发票选项',
    productType: '产品类型',
    invoiceType: '发票类型',
    exportType: '出口类型',
    dangerousGoods: '危险品内容',
    invoiceDate: '发票日期',
    invoiceNumber: '发票号码',
    invoiceAttachment: '发票文件',
    invoiceAttachmentFormat: '发票上传附件格式',
    importerName: '进口方联系人姓名',
    importerCompany: '进口方公司名称',
    importerPhone: '进口方电话',
    importerCountry: '进口方国家/地区',
    importerPostcode: '进口方邮编',
    importerCity: '进口方城市',
    importerAddress1: '进口方地址1',
    importerAddress2: '进口方地址2',
    importerAddress3: '进口方地址3',
    masterSubOrder: '子母单（一票多件）',
    subOrderCount: '子单数量'
  },
  contactEnglish: {
    parties: {
      shipper: '发货人',
      recipient: '收货人'
    },
    fields: {
      company: '公司名称',
      postcode: '邮编',
      contactName: '联系人',
      phone: '联系电话',
      province: '省/州',
      city: '城市',
      district: '区县',
      address: '详细地址'
    }
  },
  placeholders: {
    selectCarrierFirst: '请先选择供应商',
    selectAccount: '请选择账户',
    selectPickupTime: '请选择取件时间',
    selectDutyPayment: '请选择税费支付方',
    dutyAccount: '请输入或选择历史税费账号',
    optionalDutyAccount: '选填，可输入或选择历史税费账号',
    selectShipperPartyType: '请选择发件地址类型',
    selectRecipientPartyType: '请选择收件地址类型',
    englishName: '从委托单带出，可修改',
    optionalEnglishName: '选填，从委托单带出，可修改',
    transportRemark: '选填，从委托单物流信息自动带出',
    selectShipperCountry: '请选择发件国家',
    selectRecipientCountry: '请选择收件国家',
    shipperPostcode: '请输入发件邮编',
    recipientPostcode: '请输入收件邮编',
    recipientTaxId: '选填，输入或选择历史税号/VAT',
    bookingNumber: '默认虚拟号码，可手动修改',
    loadCount: '请输入箱数',
    batteryDetails: '可多选，未选择表示无电池',
    selectFedexDocumentType: '请选择单据类型',
    invoiceOptional: '选填，留空表示不需要发票',
    productType: '选填，不传默认为包裹',
    invoiceType: '选填，不传默认为商业发票',
    invoiceNumber: '默认取关联发货申请单号',
    invoiceFormat: '上传文件后自动识别',
    importerCountry: '选填，传二字码',
    importerCity: '请选择或输入城市',
    subOrderCount: '请输入1至999的物理件数'
  },
  hints: {
    dhlInvoiceFormats: '支持 PDF / PNG / TIFF / GIF / JPEG，上传后自动识别格式',
    recipientTaxIdHistory: '按当前登录人记忆 FedEx 税号；保存草稿或下单成功后记录。',
    bookingNumberEdit: '保存后更新预定号码，不会再次提交快递下单。',

    fedexWeightService: '下单产品：{service}。重量由 eTower 校验；如报错，请根据错误提示自行决定是否更换产品。',
    productSource: '从委托单带出全部商品，行序保持一致。',
    productSelection: '仅勾选行下发，最多 4 条；数量、含税单价必填；英文描述留空时使用物流英文品名。',
    productDefaults: '默认按英文描述去重后取委托单数量最大的 4 行，同描述保留数量较大的行；弹窗数量默认 1。',
    productEditsOnly: '描述编辑会去重汇总到物流品名；FedEx 锂电池描述自动添加 PI 前缀。商品修改仅用于快递下单，不回写委托单商品明细。',
    originCountryWriteBack: '从委托单带出，可修改；下单成功后回写委托单原位置。',
    noExclusiveInformation: '当前快递供应商无需填写专属信息，可直接确认下单。',
    pickupPending: '下单成功后，请登录对应快递商官网或联系客服补充取件时间安排',
    dhlAccountCountry: '发件国家须与所选 DHL 账号的注册国家一致。',
    dhlDutyAccountValidation: 'DHL 会校验税费支付账号，请填写真实有效的账号。',
    brokerCountryRequired: '请选择代理人国家，可按中文名、英文名或二字码检索。',
    fedexFileUpload: '最多上传5个文件；每个文件须选择不同的单据类型。',
    pieceSummary: '合计：{weight} kg / {volume} m³'
  },
  contactTable: {
    shipperAddress: '发货地址',
    consigneeAddress: '收货地址'
  },
  productTable: {
    onLabel: '下发',
    selectRow: '下发第 {row} 行商品',
    sequence: '序号',
    productName: '产品名称',
    quantity: '数量',
    unitPriceAll: '含税单价',
    cnDesc: '中文描述',
    enDesc: '英文描述'
  },
  table: {
    source: '数据来源',
    boxQty: '纸箱数',
    totalVolume: '总体积 (m³)',
    totalWeight: '总重量 (kg)',
    length: '长 (cm)',
    width: '宽 (cm)',
    height: '高 (cm)',
    rowNumber: '行号',
    sku: 'SKU',
    productName: '商品名称',
    englishName: '英文品名',
    exportHsCode: '出口 HSCode',
    importHsCode: '进口 HSCode'
  },
  metricSources: {
    theoretical: '理论值',
    warehouse: '仓库数据'
  },
  pieceTable: {
    referenceNo: '子单号',
    boxSeq: '箱序',
    weight: '毛重 (kg)',
    volume: '体积 (m³)',
    length: '长 (cm)',
    width: '宽 (cm)',
    height: '高 (cm)'
  },
  options: {
    carriers: {
      sf: '顺丰',
      ems: 'EMS',
      fedex: 'FedEx',
      dhl: 'DHL'
    },
    products: {
      sfExpress: '顺丰特快',
      sfStandard: '顺丰标快',
      sfExpressD: '特快D类',
      sfFreight: '顺丰卡航',
      sfFreightD: '顺丰卡航D类',
      emsExpress: 'EMS特快专递',
      fedexPriority: 'FedEx国际优先',
      fedexEconomy: 'FedEx国际经济',
      fedexPriorityFreight: 'FedEx国际优先货运',
      dhlWorldwide: 'DHL快件',
      dhlEconomy: 'DHL经济快件'
    },
    packagingType: {
      yourPackaging: '自备包装',
      fedexEnvelope: 'FedEx信封'
    },
    paymentType: {
      sender: '发件人付'
    },
    batteryDetails: {
      lithiumIonPackedWithEquipment: '锂离子电池与设备包装在一起(UN3481.PI966)',
      lithiumIonContainedInEquipment: '锂离子电池包含在设备中(UN3481.PI967)',
      lithiumMetalPackedWithEquipment: '锂金属电池与设备包装在一起(UN3091.PI969)',
      lithiumMetalContainedInEquipment: '锂金属电池包含在设备中(UN3091.PI970)'
    },
    dutyPayment: {
      sender: '发件人付',
      recipient: '收件人付',
      thirdParty: '第三方付',
      collect: '到付'
    },
    shipmentPurpose: {
      gift: '礼品',
      notSold: '非出售',
      personalEffects: '私人物品',
      repairAndReturn: '维修和进货',
      sample: '样品',
      sold: '出售'
    },
    fedexDocumentType: {
      certificateOfOrigin: '原产地证书',
      commercialInvoice: '商业发票',
      etdLabel: '发货面单',
      other: '其他',
      proFormaInvoice: '形式发票',
      usmcaCertificationOfOrigin: 'USMCA原产地证书',
      usmcaCommercialInvoiceCertificationOfOrigin: 'USMCA商业发票/原产地证明'
    },
    fedexUploadStatus: {
      pending: '待上传',
      success: '上传成功',
      failed: '上传失败'
    },
    dhlInvoice: {
      none: '不需要发票',
      generated: 'DHL 发票',
      customerUpload: '客户上传'
    },
    dhlProductType: {
      parcel: '包裹',
      document: '文件'
    },
    dhlInvoiceType: {
      commercial: '商业发票',
      proforma: '形式发票'
    },
    dhlExportReason: {
      permanent: '永久出口',
      temporary: '临时出口',
      return: '退货',
      exhibitionReturn: '展览品退回原产地',
      intercompanyUse: '公司内部使用',
      commercialPurpose: '商业用途或销售',
      personalUse: '个人物品或个人使用',
      sample: '样品',
      gift: '礼品',
      returnToOrigin: '退回原产地',
      warrantyReplacement: '保修更换',
      diplomaticGoods: '外交物品',
      defenceMaterial: '国防物资'
    },
    dhlDangerousType: {
      hd: '锂离子电池 PI965-966 第 II 节',
      hv: '锂离子电池 PI967 第 II 节',
      hm: '锂金属电池 PI969 第 II 节',
      hw: '锂金属电池 PI970 第 II 节'
    }
  },
  messages: {
    fieldTooLong: '{field}不能超过 {max} 字符',
    currencyInvalid: '币种须为有效的三字母 ISO 币种代码',
    contactTextInvalid: '{field}须使用英文或法文，且不能为纯数字',
    theoreticalMetricInvalid: '理论件重尺不得为负数',
    fedexBrokerCountryInvalid: '请选择有效的代理人国家',

    productSelectionMax: '最多勾选 {max} 条商品，请先取消其他勾选',
    productSelectionRequired: '请勾选 1 至 {max} 条商品后再下单',
    productChineseTooLong: '第 {row} 行商品中文描述不能超过 255 字符',
    productItemsEmpty: '委托单暂无商品明细，无法快递下单',
    productQuantityInvalid: '第 {row} 行商品数量须为 1 至 2147483647 的整数',
    productUnitPriceInvalid: '第 {row} 行商品含税单价须大于 0',
    productEnglishInvalid: '第 {row} 行商品描述须为英文或法文，留空时使用物流英文品名，含 FedEx 前缀不超过 60 字符',
    loadAccountsFailed: '加载下单账户失败，请稍后重试',
    missingOrderForFedexUpload: '缺少委托单ID，无法上传 FedEx 文件',
    fedexUploadMissingId: 'FedEx 文件上传成功但未返回文件ID',
    fileStored: '{fileName} 已存入文件管理',
    fedexUploadFailed: 'FedEx 文件上传失败，请重试',
    missingOrderForInvoiceUpload: '缺少委托单ID，无法上传发票',
    unsupportedInvoiceFormat: '仅支持 PDF/PNG/TIFF/GIF/JPEG 发票文件',
    dhlUploadFailed: 'DHL发票上传失败，请重试',
    dhlUploadMissingId: 'DHL发票上传未返回文件ID，请重新上传',
    dhlUploading: 'DHL发票正在上传，请稍候',
    incomplete: '请完整填写快递下单信息',
    selectOriginCountry: '请选择原产国',
    originCountryInvalid: '请选择有效的原产国，国家代码须为二字码',
    etowerWeightInvalid: '实际下发重量须大于或等于0.000001 kg',
    etowerVolumeInvalid: '实际下发体积须大于或等于0.01 m³',
    etowerDimensionsInvalid: '实际下发的长宽高须为正数，DHL三项均必填',
    weightPositiveInteger: '总重量须为正整数',
    metricPositiveInteger: '{field}须为正整数',
    boxQtyInvalid: '纸箱数须为有效的非负整数',
    subOrderCountInvalid: '子单数量须为1至999的整数，且明细行数须一致',
    pieceBoxSeqInvalid: '子单第{row}行箱序须为正整数',
    pieceWeightInvalid: '子单第{row}行毛重须为正数且最多保留两位小数',
    pieceVolumeInvalid: '子单第{row}行体积须为正数且最多保留两位小数',
    pieceDhlDimensionsInvalid: 'DHL子单第{row}行长、宽、高均须为正数且最多保留两位小数',
    pieceDimensionsInvalid: '子单第{row}行长、宽、高填写后须为正数且最多保留两位小数',
    stepValidationFailed: '页面校验失败，请重试',
    selectShipperCountry: '请选择发件国家',
    selectRecipientCountry: '请选择收件国家',
    crossBorderCountrySame: 'FedEx/DHL 为跨境快递，发件国家与收件国家不能相同',
    shipperAddressMissing: '所选发件地址未维护，请先在收发通信息中补充',
    recipientAddressMissing: '所选收件地址未维护，请先在收发通信息中补充',
    contactDivisionRequired: '请填写收发通信息{party}的{field}',
    contactEnglishRequired: '收发通信息{party}的{field}不能包含中文汉字',
    selectDutyPayment: '请选择税费支付方',
    dutyAccountRequired: '请填写税费支付账号',
    selectDhlIncoterm: '请选择 DHL 贸易条款',
    selectFedexPackagingType: '请选择 FedEx 包装类型',
    selectFedexPaymentType: '请选择 FedEx 费用支付方',
    fedexBookingRequired: '请填写 FedEx 预定号码',
    fedexLoadCountInvalid: '请填写有效的 FedEx 箱数',
    fedexUploading: 'FedEx 文件正在上传，请稍候',
    fedexFileRequired: '请上传 FedEx 文件',
    fedexFileCountExceeded: 'FedEx 文件最多上传{max}个',
    fedexFileTypeUnsupported: 'FedEx 文件仅支持 BMP、DOC、DOCX、GIF、JPG、PDF、PNG、RTF、TIFF、TXT、XLS、XLSX',
    fedexDocumentTypeRequired: '请为每个 FedEx 文件选择单据类型',
    fedexDocumentTypeDuplicate: '每个 FedEx 文件须选择不同的单据类型',
    fedexPostUploadFailed: '快递下单已成功，但 FedEx 文件上传 eTower 失败；请结合后端日志处理，勿重复下单',
    fedexBrokerFieldRequired: '请填写{field}',
    fedexBrokerCountryMismatch: '代理人国家须与收件人国家一致',
    dhlInvoiceRequired: 'DHL发票日期和发票号码不能为空',
    dhlInvoiceFileRequired: '请上传有效的 DHL 发票文件，格式由系统自动识别',
    dhlImporterCountryInvalid: 'DHL进口方国家/地区须为二字码',
    sfFieldsLoading: '顺丰专属信息尚未加载，请稍后重试',
    missingOrderForSubmit: '缺少委托单ID，无法快递下单',
    missingOrderForDraft: '缺少委托单ID，无法暂存草稿',
    draftSaved: '草稿已保存',
    draftSaveFailed: '暂存草稿失败，请重试',
    draftLoadFailed: '加载快递下单草稿失败，已使用委托单最新数据',
    orderSuccess: '快递下单成功，运单号：{trackingNo}',
    orderFailed: '快递下单失败，请重试',
    labelDefaultError: '获取面单失败，请检查网络后重试',
    labelMissingOrder: '缺少委托单ID，无法获取面单',
    labelStillPending: '面单仍在获取中，请稍后在详情页重新打开查看',
    labelRetryFailed: '获取面单失败，请稍后重试'
  },
  label: {
    title: '获取面单',
    loading: '正在获取面单...',
    success: '面单获取成功',
    saved: '已保存到文件管理',
    failed: '获取面单失败',
    retry: '获取面单'
  },
  detail: {
    pieceItems: '子母单明细',
    pieceTrackingNo: '子单快递单号',
    pieceStatus: '下单状态',
    productItems: '下单商品明细',
    serviceTitle: '快递服务',
    sfTitle: '顺丰专属信息 · 增值服务',
    dhlTitle: 'DHL 专属信息',
    fedexTitle: 'FedEx 专属信息',
    trackingNo: '快递运单号',
    service: '快递服务',
    dimensions: '尺寸',
    shipper: '发件人快照',
    recipient: '收件人快照'
  },
  sf: {
    title: '顺丰专属信息',
    valueAddedService: '增值服务',
    helper: '勾选需要的增值服务；有参数的勾选后展开填写。',
    simpleHint: '仅勾选即可',
    parameterHint: '需填写参数（勾选后展开）',
    services: {
      cod: '代收货款',
      homeDelivery: '宅配延伸',
      delegatedPickup: '委托取件',
      batchDelivery: '到齐再派',
      installation: '安装服务',
      credential: '密钥认证',
      insured: '足额保',
      timedDelivery: '定时派送（指定时段）',
      policyDelivery: '保单配送',
      selfPickup: '自取件',
      documentDelivery: '票据专送',
      traceability: '溯源服务',
      packing: '打包服务',
      returnTransfer: '惠转退',
      notifiedDelivery: '定时派送（等通知）',
      onTimeGuarantee: '准时保',
      recipientMicroDelivery: '收件微派',
      deliveryMicroDelivery: '派件微派',
      packaging: '包装服务',
      electronicReceipt: '签回单-电子回单',
      standardizedPackaging: '标准化包装服务',
      paperReceipt: '签回单-纸质回单',
      photoReceipt: '签回单-拍照回传'
    },
    fields: {
      receiptResourceCode: '回单资源编码',
      electronicReceiptFile: '电子回单文件',
      receiptRequirements: '回单要求',
      photoCount: '照片张数',
      returnedContent: '回传要求',
      installationType: '安装类型',
      credentialType: '认证方式',
      credentialLastSix: '身份证后 6 位',
      insuredAmount: '保价金额',
      deliveryDate: '派送日期',
      deliveryTime: '派送时间段',
      codAmount: '货款',
      codCard: '收货款卡号',
      homeRuleId: '宅配规则ID',
      homeRuleName: '宅配名称',
      serviceQuantity: '服务项数量',
      pickupMethod: '取件方式',
      scene: '场景',
      batchNo: '批次号'
    },
    placeholders: {
      resourceCode: '请输入资源编码',
      selectElectronicReceiptFile: '选择电子回单文件',
      credentialLastSix: '请输入身份证号码后6位',
      insuredAmount: '请输入足额保保价',
      codAmount: '以原寄地币种为准，保留三位小数',
      codCard: '请输入收货款卡号',
      customerCodeTimestamp: '客户编码+时间戳'
    },
    hints: {
      credentialPassword: '口令由顺丰自动生成，并通过短信发送给收件人。',
      credentialIdCard: '请填写身份证号码后6位，并自行通知收件人。'
    },
    actions: {
      deleteHomeDelivery: '删除宅配项',
      addHomeDelivery: '新增宅配项'
    },
    options: {
      integrated: '送装一体',
      separate: '送装分离',
      confidential: '保密',
      withLetter: '带函',
      confidentialWithLetter: '保密 + 带函',
      password: '口令',
      idCard: '身份证',
      passwordOrIdCard: '口令 + 身份证',
      parentChildScene: '子母件场景',
      warehouseScene: '分仓场景',
      signature: '签名',
      stamp: '盖章',
      registerId: '登记身份证号',
      collectIdCopy: '收取身份证复印件',
      collectDeliveryStub: '收取派件存根（香港专用）',
      otherHongKongFile: '其他文件（香港专用）',
      receiptDate: '签收日期',
      phone: '电话号码',
      idNumber: '身份证号码',
      signatureStamp: '签名 + 盖章',
      signatureId: '签名 + 身份证号码',
      stampId: '盖章 + 身份证号码',
      signatureStampId: '签名 + 盖章 + 身份证号码'
    },
    messages: {
      codAmountInvalid: '请填写有效的顺丰代收货款金额',
      codCardRequired: '请填写顺丰代收货款卡号',
      homeDeliveryRequired: '请至少填写一项顺丰宅配服务',
      homeDeliveryIncomplete: '请完整填写顺丰宅配规则ID、名称和正整数数量',
      homeDeliveryCommaInvalid: '顺丰宅配规则ID和名称不能包含英文逗号',
      delegatedPickupRequired: '请选择顺丰委托取件类型',
      batchSceneRequired: '请选择顺丰到齐再派场景',
      batchNoRequired: '请填写顺丰到齐再派批次号',
      installationRequired: '请选择顺丰安装服务类型',
      credentialTypeRequired: '请选择顺丰密钥认证类型',
      credentialNoInvalid: '顺丰密钥认证身份证号码须填写后6位',
      insuredAmountInvalid: '请填写有效的顺丰足额保保价',
      timedDeliveryRequired: '请选择顺丰定时派送日期和时段',
      electronicReceiptRequired: '请填写顺丰电子回单资源编码',
      electronicReceiptFileRequired: '请选择顺丰电子回单文件',
      electronicReceiptFileEmpty: '顺丰电子回单文件不能为空',
      electronicReceiptFileTooLarge: '顺丰电子回单文件不能超过 20MB',
      electronicReceiptFileTypeInvalid: '顺丰电子回单仅支持 pdf、doc、docx、xls、xlsx、ppt、pptx、jpg、jpeg、png 格式',
      electronicReceiptFileNameInvalid: '顺丰电子回单文件名不能包含 / \\ : * ? " < > | 或 Emoji 表情',
      electronicReceiptFileChanged: '顺丰电子回单文件已变更，请重新确认下单',
      electronicReceiptUploadFailed: '顺丰电子回单上传失败，未取得资源编码',
      paperReceiptRequired: '顺丰纸质签回单至少选择一项签收要求',
      photoCountInvalid: '请填写顺丰拍照回传照片张数',
      photoTypeRequired: '顺丰拍照回传至少选择一项回传要求',
      photoTypeInvalid: '请选择有效的顺丰拍照回传要求'
    }
  }
}
